import { Box, Card, H1, H2, Separator } from '@betterment/samba-react';

import { ResourcesCard } from './resources-card/ResourcesCard';

import { ApplicationLayout } from '../layout/ApplicationLayout';

export const HomePage = () => {
  return (
    <ApplicationLayout pageTitle="Reports">
      <ApplicationLayout.Header>
        <H1 variant="pageTitle">Dashboard home</H1>
      </ApplicationLayout.Header>
      <ApplicationLayout.Content>
        <Box
          css={{
            display: 'grid',
            gridTemplateColumns: { base: '1fr', md: '2fr 1fr' },
            gap: 'space.300',
            alignItems: 'start',
          }}
        >
          {/* Left column */}
          <Box
            css={{
              display: { base: 'contents', md: 'flex' },
              flexDirection: 'column',
              gap: 'space.300',
            }}
          >
            <Box css={{ order: { base: 1 } }}>
              <Card css={{ p: 'space.300' }}>
                <Card.Header>
                  <H2 variant="title200">Tasks</H2>
                  <Separator css={{ my: 'space.300' }} />
                  {/* This is a naive implementation, assuming that there are no tasks */}
                  {/* Add dynamic task rendering in follow up */}
                  You're all caught up!
                </Card.Header>
              </Card>
            </Box>

            <Box css={{ order: { base: 2 } }}>
              <Card css={{ p: 'space.300' }}>
                <Card.Header>
                  <H2 variant="title200">Plan insights</H2>
                </Card.Header>
              </Card>
            </Box>

            <Box css={{ order: { base: 6 } }}>
              <ResourcesCard />
            </Box>
          </Box>

          {/* Right column */}
          <Box
            css={{
              display: { base: 'contents', md: 'flex' },
              flexDirection: 'column',
              gap: 'space.300',
            }}
          >
            {/* CTA buttons placeholder — hidden on small screens */}
            <Box css={{ display: { base: 'none', md: 'block' } }}>CTAs</Box>

            <Box css={{ order: { base: 3 } }}>
              <Card css={{ p: 'space.300' }}>
                <Card.Header>
                  <H2 variant="title200">Payroll</H2>
                </Card.Header>
              </Card>
            </Box>

            <Box css={{ order: { base: 4 } }}>
              <Card css={{ p: 'space.300' }}>
                <Card.Header>
                  <H2 variant="title200">Support</H2>
                </Card.Header>
              </Card>
            </Box>

            <Box css={{ order: { base: 5 } }}>
              <Card css={{ p: 'space.300' }}>
                <Card.Header>
                  <H2 variant="title200">Additional benefits</H2>
                </Card.Header>
              </Card>
            </Box>
          </Box>
        </Box>
      </ApplicationLayout.Content>
      <ApplicationLayout.Footer />
    </ApplicationLayout>
  );
};
